import {config} from 'rxjs';
import {ActivityQueueItem, Configuration} from '../activity-queue-item.js';
import Decimal, {DecimalSource} from '../break_infinity.js';
import {Gettable} from '../types/runner-idle.js';

export type DynamicValue = (
  step: number,
  optionIndex: number,
  configuration: Configuration
) => DecimalSource;

export type DynamicCost = Map<
  string, // Gettable
  {value: DynamicValue; string?: DynamicValue; weight?: DynamicValue}
>;

export type Cost = Map<
  string /* Gettable */,
  {value: DecimalSource; string?: DecimalSource}
>;

export function evaluateCost(
  cost: DynamicCost,
  step: number,
  optionIndex: number,
  configuration: Configuration
): Cost {
  const totalWeight = [...cost].reduce(
    (acc, [, {weight}]) =>
      acc.plus(weight?.(step, optionIndex, configuration) ?? new Decimal(0)),
    new Decimal(0)
  );
  if (totalWeight.gt(0)) {
    const chosenWeight = totalWeight.times(Math.random()).plus(1).floor();
    let weightLeft = chosenWeight;
    const chosenWeightedItem: Gettable = [...cost].reduce(
      (acc, [key, {weight}]) => {
        if (weight && acc === 'nothing') {
          weightLeft = weightLeft.minus(
            weight(step, optionIndex, configuration)
          );
          if (weightLeft.lte(0)) {
            return key;
          }
        }
        return acc;
      },
      'nothing' as Gettable
    );
    return new Map(
      [...cost]
        .filter(([, {weight}]) => weight === undefined)
        .concat([[chosenWeightedItem, cost.get(chosenWeightedItem)!]])
        .map(([key, {value, string}]) => {
          return [
            key,
            {
              value: value(step, optionIndex, configuration),
              string: string?.(step, optionIndex, configuration),
            },
          ];
        })
    );
  } else {
    return new Map(
      [...cost].map(([key, {value, string}]) => {
        return [
          key,
          {
            value: value(step, optionIndex, configuration),
            string: string?.(step, optionIndex, configuration),
          },
        ];
      })
    );
  }
}
